var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "div-block-102"
  }, [_c('div', {
    staticClass: "div-block-104"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": require("@/images/avatar_applicants.png"),
      "loading": "lazy",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "div-block-103"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v("Bonita žiadateľ" + _vm._s(_vm.coApplicantPresent ? "ov" : "a"))])])]), !_vm.missingInfo ? _c('div', {
    staticClass: "input-block contrast"
  }, [_vm._m(0)]) : _vm._e()]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "div-block-101 apart"
  }, [_c('img', {
    attrs: {
      "src": require("@/images/verified_icon.png"),
      "loading": "lazy",
      "width": "30",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "bold"
  }, [_vm._v(" Trieda A ")])]);

}]

export { render, staticRenderFns }